import { useEffect, useRef } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Hook that polls for Fully Kiosk commands and executes them.
 * Works with Fully Kiosk Browser's JavaScript interface.
 */
const useFullyKiosk = (displayId) => {
  const pollRef = useRef(null);

  useEffect(() => {
    if (!displayId) return;

    const hasFully = () => typeof window.fully !== 'undefined';

    const executeCommand = (cmd) => {
      const { command, params } = cmd;

      switch (command) {
        case 'reload':
          if (hasFully()) {
            window.fully.loadStartUrl();
          } else {
            window.location.reload();
          }
          break;

        case 'loadUrl':
          if (params?.url) {
            if (hasFully()) {
              window.fully.loadUrl(params.url);
            } else {
              window.location.href = params.url;
            }
          }
          break;

        case 'screenOn':
          if (hasFully()) {
            window.fully.screenOn();
            window.fully.setBooleanSetting('screenOffTimer', false);
          }
          break;

        case 'screenOff':
          if (hasFully()) {
            window.fully.screenOff();
          }
          break;

        case 'restart':
          if (hasFully()) {
            window.fully.restartApp();
          } else {
            window.location.reload();
          }
          break;

        case 'setBrightness':
          if (hasFully() && params?.brightness !== undefined) {
            window.fully.setScreenBrightness(params.brightness);
          }
          break;

        case 'clearCache':
          if (hasFully()) {
            window.fully.clearCache();
            window.fully.loadStartUrl();
          } else {
            window.location.reload();
          }
          break;

        default:
          console.log('Unknown command:', command);
      }
    };

    const pollCommands = async () => {
      try {
        const response = await axios.get(`${API}/fully/commands/${displayId}`);
        const commands = response.data?.commands || [];
        for (const cmd of commands) {
          executeCommand(cmd);
        }
      } catch (error) {
        // Silent fail - don't spam console on poll errors
      }
    };

    // Poll every 5 seconds
    pollCommands();
    pollRef.current = setInterval(pollCommands, 5000);

    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [displayId]);
};

export default useFullyKiosk;
